import { render } from "./WpeSlider.vue?vue&type=template&id=fcdac6da"
import script from "./WpeSlider.vue?vue&type=script&lang=js"
export * from "./WpeSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/options-controls/WpeSlider.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fcdac6da"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fcdac6da', __exports__)) {
    api.reload('fcdac6da', __exports__)
  }
  
  module.hot.accept("./WpeSlider.vue?vue&type=template&id=fcdac6da", () => {
    api.rerender('fcdac6da', render)
  })

}


export default __exports__